<template>
  <div class="text-xs-center">
    <v-snackbar
      v-model="show"
      :color="$store.getters.alertColor"
      :to="true"
      top
    >
      {{ $store.getters.alertMessage }}
      <v-btn
        dark
        text
        class="font-weight-bold"
        @click="$store.dispatch('SetAlert', {showAlert: false, message: '', color: ''})"
      >
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
export default {
  props: ['status', 'message', 'color'],
  data () {
    return {
      show: this.$store.getters.showAlert
    }
  },
  watch: {
    show: {
      handler (value) {
        this.$store.dispatch('SetAlert', {showAlert: value, message: '', color: ''})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/View/components/SnakBar.vue